<template>
  <div>
    <div class="materials">
      <p v-if="isCategoryAdvanced" class="attention mb-0">{{attentionMessage}}</p>
      <v-category-button v-for='material in materials'
        @click="setQuestionRangeType(material.id)"
        :key="material.id"
        :type="material.type"
        :active="selectedQuestionRangeType == material.id"
        :disabled="material.disabled"
      >
        {{material.text}}
      </v-category-button>
    </div>
  </div>
</template>

<script>
import VCategoryButton from '@/components/atoms/CategoryButton'
import config from '../../config'
export default {

  components: {
    VCategoryButton
  },

  data: () => ({
  }),

  computed: {
    //TODO:getter,setterでひとまとめにする（methodは不要）
    selectedQuestionRangeType() {
      return this.$store.state.conditions.selectedQuestionRangeType;
    },
    materials() {
      const materials = [{id: 1, text: 'ページから選択', type: 'page', disabled: false}]
      if(this.$store.state.conditions.selectedSearchType === config.searchType.PUBLISHER
         ||
         this.$store.state.conditions.selectedSearchType === config.searchType.GET_THROUGH && this.$store.state.conditions.selectedCategory === 3
        ) {
          materials.push({id: 2, text: '単元から選択', type: 'tangen', disabled: false})
      } else if(this.$store.state.conditions.selectedSearchType === config.searchType.GET_THROUGH && this.$store.state.conditions.selectedCategory !== 3) {
        materials.push({id: 3, text: '見出し番号から選択', type: 'midashi-range', disabled: false})
      }
      return materials
    },
    isCategoryAdvanced() {
      return this.$store.getters['conditions/isCategoryAdvanced']
    },
    showOppositeAttention() {
      return Object.entries(this.$store.state.conditions.questionNumAreas)
        .filter(([, attribute]) => attribute.displayFlg)
        .map(([key, ]) => key).join(',').includes('Opposite')
    },
    attentionMessage() {
      let message = '※「例文問題」「活用問題」'
      if (this.showOppositeAttention) message += '「反意語問題」'
      message += 'すべてに適用されます。'
      return message
    }
  },

  methods: {
    setQuestionRangeType(index) {
      this.$store.commit('conditions/setResetRange', {
        rangeType: index,
        masterUnits: this.$store.state.master.allUnits
      })
      this.$store.commit('conditions/setSelectedQuestionRangeType', {
        rangeType: index
      })
    }
  },

  watch: {
  }
}
</script>

<style lang="stylus" scoped>
.materials
  max-width 800px

.shakai-options
  margin-top 20px
  max-width 800px

.attention
  font-size 12px
</style>
